import { createFileRoute, notFound } from "@tanstack/react-router";
import { UiGallery } from "../app/dev/ui-gallery";

// Development builds only: production answers not found and its build drops the gallery.
export const Route = createFileRoute("/_app/dev/ui")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: DevUi,
});

function DevUi() {
  return import.meta.env.DEV ? <UiGallery /> : null;
}
